import { render, staticRenderFns } from "./crumb_bar.vue?vue&type=template&id=2ffd517d&scoped=true&"
import script from "./crumb_bar.vue?vue&type=script&lang=js&"
export * from "./crumb_bar.vue?vue&type=script&lang=js&"
import style0 from "./crumb_bar.vue?vue&type=style&index=0&id=2ffd517d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffd517d",
  null
  
)

export default component.exports